import { requestJson } from '@/assets/modules/request'

/**
 * 総センサー数のJSONデータを取得する
 */
export function getSensorCountListJson() {
  return requestJson.get(`/sensorCountList.json`)
}
